import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { DifficultyEnum, GameModel } from '../../../../Models/Game/GameModel';
import { ButtonController, IButtonControllerOptions } from './ButtonController';
import { GameLogic } from '../../../../Logic/GameLogic';
import { AnimationContents } from '../../../../../AnimationContents';

export interface IChoiceDifficultyScreenControllerOptions {
}

export class SelectDifficultyController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IChoiceDifficultyScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _modelEvents: ModelEvents) {
        super("SelectDifficultyController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.DIFFICULTY_SCREEN_JSON,
            libraryName: "main",
            childControllers: {
                btn_easy: {
                    instanceName: "container.window.btn_easy",
                    view: ButtonController,
                    options: <IButtonControllerOptions>{
                        active: false,
                        difficulty: DifficultyEnum.easy,
                        onClick: (name) => this._changeDifficultly(name)
                    }
                },
                btn_medium: {
                    instanceName: "container.window.btn_medium",
                    view: ButtonController,
                    options: <IButtonControllerOptions>{
                        active: false,
                        difficulty: DifficultyEnum.medium,
                        onClick: (name) => this._changeDifficultly(name)
                    }
                },
                btn_hard: {
                    instanceName: "container.window.btn_hard",
                    view: ButtonController,
                    options: <IButtonControllerOptions>{
                        active: false,
                        difficulty: DifficultyEnum.hard,
                        onClick: (difficulty) => this._changeDifficultly(difficulty)
                    }
                },
                btn_close: {
                    instanceName: "container.window.btn_close",
                    view: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.$queue.get('close').addToQueue();
                        }
                    }
                }
            },
            queue: {
                close: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        this.gotoAndPlayByQuery("container", "window close", false, false);
                        this.$queue.get('hideAndClose').addToQueue();
                    }
                },
                play: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        this.gotoAndPlayByQuery("container", "window close", false, false);
                        this.$queue.get('hideAndPlay').addToQueue();
                    }
                },
                hideAndPlay: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        this._gameLogic.showMenuSelectCharacter()
                    }
                },
                hideAndClose: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        this._gameLogic.resetMenu()
                    }
                },
            }
        };
    }

    private _changeDifficultly(name: DifficultyEnum): void {
        this.$childControllers.items.forEach(item => {
            this.$childControllers.get<ButtonController>(item.name).display.interactive = false;
            this.$childControllers.get<ButtonController>(item.name).display.buttonMode = false;
            this.$childControllers.get<ButtonController>(item.name).gotoAndStop('active');
        });
        this.$queue.get('play').addToQueue();

        this._gameLogic.setDifficulty(name);
    }

    protected onInitialize(): void {
        this.gotoAndPlayByQuery("container", "window initialization", false, false);
    }

    protected onLandscape(): void {
        this.display.scale.set(1.3);
        this.display.y = 25;
    }
}

